import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import ServicesPage from "@/pages/Services";
import GalleryPage from "@/pages/Gallery";
import AboutPage from "@/pages/About";
import TestimonialsPage from "@/pages/Testimonials";
import ContactPage from "@/pages/Contact";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import Confidentialite from "@/pages/legal/Confidentialite";
import CGV from "@/pages/legal/CGV";
import NotFound from "@/pages/NotFound";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/realisations" element={<GalleryPage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/temoignages" element={<TestimonialsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          style: { fontFamily: "Manrope, sans-serif" },
        }}
      />
    </div>
  );
}

export default App;
